import React, {Component} from 'react'
import {Wizard} from "../../../components";
import "./PublicForm.css"
import DateUtil from "../../../utils/DateUtil";
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import ConsentFormPartsRad from "../utils/ConsentFormPartsRad";
import FormLanguages from "../enum/FormLanguages";
import InformedConsentSignatureInputs from "../informedconsent/InformedConsentSignatureInputs";
import InformedConsentFormRadTextEnum from "../informedconsent/enum/InformedConsentFormRadTextEnum";
import ClinicLogo from "../../../layout/ClinicLogo";

export default class PublicInformedConsentFormRad extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    createHeader = (form, formBodyClass) => {
        const {language} = this.props;

        return <div className={formBodyClass} style={{padding: "0px 20px 0px 20px"}}>
            <div className="row text-left">
                <div className="col-12 no-padding">
                    <ClinicLogo/>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center no-padding" style={{fontSize: 20, fontWeight: "bold"}}>
                    {InformedConsentFormRadTextEnum.Informed_Consent_Form[language]}
                </div>
            </div>
            <div className="row justify-content-between" style={{fontSize: 11}}>
                <div>
                    <b>{InformedConsentFormRadTextEnum.Date_Of_Admission[language]}: </b> {DateUtil.formatDateMMM(form.consentDate)}
                </div>
                <div>
                    <b>{InformedConsentFormRadTextEnum.MRN[language]}: </b> {form.patientMrn}
                </div>
                <div>
                    <b>{InformedConsentFormRadTextEnum.ID_No[language]}: </b> {form.patientEId}
                </div>
                <div>
                    <b>{InformedConsentFormRadTextEnum.Date_Of_Birth[language]}: </b> {DateUtil.formatDateMMM(form.patientDOB)}
                </div>
            </div>
        </div>
    };

    fieldChanged = (fieldName, value) => {
        this.props.form[fieldName] = value;
        this.forceUpdate();
    };

    onSavePatientSignature = (signature) => {
        this.props.form.patientSignature = signature;
        this.forceUpdate();
    }

    onSaveWitnessSignature = (signature) => {
        this.props.form.witnessSignature = signature;
        this.forceUpdate();
    }

    close = () => {
        confirmDialog(
            'Confirmation',
            'Are you sure you want to close this form? All input will be lost.',
            this.props.close);
    };

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const {consentFormCode: code, form} = this.props;
            RemotingService.postRemoteCall(`api/public/consent-form/code/${code}/informed-consent-form-rad`, form);
            this.props.onFormSubmit(form);
        }
    };

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    render() {
        this.formFields = [];
        const {form, language} = this.props;
        const formBodyClass = language == FormLanguages.ARABIC.name ? "arabic-form" : "";
        const enumLabel = language == FormLanguages.ARABIC.name ? "nameInArabic" : "name";
        const commonProps = {
            selectedLanguage: language,
            pushFormFieldRef: this.pushFormFieldRef
        }

        return (
            <>
                <Wizard
                    show={true} fullScreen
                    footerStyle={{backgroundColor: '#f5f5f5'}}
                    buttonStyle={{backgroundColor: '#84BE56', border: 'none'}}

                    previousButtonStyle={{
                        backgroundColor: "#fff",
                        color: "rgb(132, 190, 86)",
                        borderColor: "rgb(132, 190, 86)"
                    }}
                    header={this.createHeader(form, formBodyClass)}
                    close={this.close}
                    onSubmit={this.submitForm}
                    previousBtnText={InformedConsentFormRadTextEnum.Wizard_Previous[language]}
                    nextBtnText={InformedConsentFormRadTextEnum.Wizard_Next[language]}
                    saveBtnText={InformedConsentFormRadTextEnum.Wizard_Save[language]}
                >

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}>
                        <div className={formBodyClass + ' m-4'}>
                            <ConsentFormPartsRad.RadiologyProcedureConsent {...commonProps}/>
                            <ConsentFormPartsRad.ModalityTypeSelection
                                {...commonProps}
                                readOnly={false}
                                modalityType={form.modalityType}
                                onChange={this.fieldChanged}
                            />
                            <ConsentFormPartsRad.RadiationRiskDeclaration
                                {...commonProps}
                                readOnly={false}
                                pregnancyStatus={form.pregnancyStatus}
                                onChange={this.fieldChanged}
                            />
                        </div>
                    </Wizard.Page>

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass + ' m-4'}>
                            <ConsentFormPartsRad.RemoteRadiologyConsent {...commonProps}/>
                            <ConsentFormPartsRad.DataCollectionAndPrivacy {...commonProps}/>
                            <ConsentFormPartsRad.HealthcareProviderGenderAcknowledgment 
                                {...commonProps}
                                genderAcknowledgment={form.genderAcknowledgment}
                                onGenderAcknowledgmentChange={(value) => this.fieldChanged('genderAcknowledgment', value)}
                                readOnly={false}
                            />
                        </div>
                    </Wizard.Page>

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass + ' m-4'}>
                            <ConsentFormPartsRad.PatientRights {...commonProps}/>
                            <ConsentFormPartsRad.QuestionsAndConcerns {...commonProps}/>
                            <ConsentFormPartsRad.Complaints {...commonProps}/>
                        </div>
                    </Wizard.Page>

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass + ' m-4'}>
                            <ConsentFormPartsRad.FinalConsent {...commonProps}/>

                            <InformedConsentSignatureInputs {...commonProps}
                                                            readOnly={false}
                                                            formFields={this.formFields}
                                                            textEnum={InformedConsentFormRadTextEnum}
                                                            consentDate={DateUtil.formatDateDo(form.consentDate)}
                                                            patientName={form.patientFullName}
                                                            providerName={form.providerName}
                                                            guardianName={form.guardianName}
                                                            guardianRelationship={form.guardianRelationship}
                                                            patientSignature={form.patientSignature}
                                                            providerSignature={form.providerSignature}
                                                            onSavePatientSignature={this.onSavePatientSignature}
                                                            onChange={this.fieldChanged}/>
                        </div>
                    </Wizard.Page>

                    <Wizard.Page onPrevious={() => this.formFields = []}>
                        <div style={{width: '1000px'}}>
                            <ConsentFormPartsRad.WitnessStatement 
                                {...commonProps}
                                consentDate={DateUtil.formatDateDo(form.consentDate)}
                                witnessName={form.witnessName}
                                witnessSignature={form.witnessSignature}
                                onWitnessNameChange={(val) => this.fieldChanged('witnessName', val)}
                                onWitnessSignatureChange={this.onSaveWitnessSignature}
                                readOnly={false}
                                formFields={this.formFields}
                                pushFormFieldRef={this.pushFormFieldRef}
                            />
                        </div>
                    </Wizard.Page>
                </Wizard>
            </>
        );
    }
}